export default __webpack_public_path__ + "4260110678b60de02d6faa37dcfdda53.png";